import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonParam } from '@app/cp/shared/models/CommonParam';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
    selector: 'dispatch-qv-window',
    templateUrl: './dispatch-qv-window.component.html',
    styleUrls: ['./dispatch-qv-window.component.scss'],
    standalone: false
})
export class DispatchQVWindowComponent implements OnInit {

  constructor() { }

  ngOnInit() {
      //alert(JSON.stringify(this.childComp) + ' ' + JSON.stringify(this.compData));
    }
    id: any;
    @Input() set Id(id: any) {
        if (CommonFunctions.hasValue(id)) {
            this.id = id;
            this.active = true;
        }
    }
    @Input() common: CommonParam;
    
    windowTitle: string = "";
    active: boolean = false;
	@Output() closed = new EventEmitter<any>(); 

    closeWindow() {
        this.active = false;
		this.closed.emit(true);
    }
    public windowTop: number = 0;
    public windowLeft: number = 0;
}
